export enum ServerEventVersion {
  V1 = 1,
}

export enum ClientEventVersion {
  V1 = 1,
}

export enum DocumentUpdateVersion {
  V1 = 1,
}

export enum CommitVersion {
  V1 = 1,
}
